import dateUtil from "../../../lib/dateUtil";

export function calculateIsYougerThenAge(insuredPersons, effectiveDate, ageInYears) {
  const oldestPerson = insuredPersons.reduce((pre, cur) => {
    const preDate = dateUtil.dutchDateToMoment(pre.dateOfBirth);
    const curDate = dateUtil.dutchDateToMoment(cur.dateOfBirth);
    return preDate.isBefore(curDate) ? pre : cur;
  });

  const age = calculateAge(effectiveDate, oldestPerson.dateOfBirth);

  return age >= ageInYears;
}

export function calculateAge(effectiveDate, personDate) {
  // Age is always calculated with -3 months
  const date = dateUtil.dutchDateToMoment(personDate).add(-3, "months");
  return dateUtil.dutchDateToMoment(effectiveDate).diff(date, "years");
}
